import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ApiService } from 'src/app/shared/services/api.service';
import { ToastrMsgService } from 'src/app/shared/services/shared-services/toastr.service';

@Component({
  selector: 'app-boq-planned-actual-deviation',
  templateUrl: './boq-planned-actual-deviation.component.html',
  styleUrls: ['./boq-planned-actual-deviation.component.css']
})
export class BoqPlannedActualDeviationComponent implements OnInit {
  boqId: number | null = null;
  loading = true;
  error: string | null = null;
  data: any = null;

  constructor(
    private route: ActivatedRoute,
    private apiService: ApiService,
    private toastr: ToastrMsgService
  ) {}

  ngOnInit(): void {
    const id = this.route.snapshot.paramMap.get('id');
    this.boqId = id ? +id : null;
    if (!this.boqId) {
      this.error = 'Invalid BoQ';
      this.loading = false;
      return;
    }
    this.load();
  }

  load(): void {
    this.loading = true;
    this.error = null;
    this.apiService.getBoQPlannedActualDeviation(this.boqId!).subscribe({
      next: (res: any) => {
        this.loading = false;
        if (res.success && res.data) {
          this.data = res.data;
        } else {
          this.error = res.error || 'Failed to load deviation report';
        }
      },
      error: (err) => {
        this.loading = false;
        this.error = err.error?.error || 'Failed to load deviation report';
        this.toastr.error(this.error || 'Failed to load deviation report');
      }
    });
  }

  formatCurrency(amount: number, currency: string = 'INR'): string {
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: currency || 'INR',
      maximumFractionDigits: 0
    }).format(amount || 0);
  }

  formatQty(value: number): string {
    const n = Number(value) || 0;
    return n.toLocaleString('en-IN', { maximumFractionDigits: 2 });
  }

  varianceClass(value: number): string {
    if (value > 0) return 'var-over';
    if (value < 0) return 'var-under';
    return 'var-flat';
  }

  signedCurrency(amount: number, currency: string = 'INR'): string {
    const n = Number(amount) || 0;
    const formatted = this.formatCurrency(Math.abs(n), currency);
    if (n > 0) return '+' + formatted;
    if (n < 0) return '−' + formatted;
    return formatted;
  }

  signedQty(value: number): string {
    const n = Number(value) || 0;
    const formatted = this.formatQty(Math.abs(n));
    if (n > 0) return '+' + formatted;
    if (n < 0) return '−' + formatted;
    return formatted;
  }
}
